import { render } from "./AddPaper.vue?vue&type=template&id=42d0d789"
import script from "./AddPaper.vue?vue&type=script&lang=js"
export * from "./AddPaper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__